var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ConfigWeb_instances, _ConfigWeb_useAccessibleLightThemeFeatureFlagChange, _ConfigWeb_actOnColorSchemePreference, _ConfigWeb_onPrefersDarkColorSchemeChange;
import Config from './Config';
import Observer from './Observer';
import NewFontFeatureFlag from './NewFontFeatureFlag';
import UseAccessibleLightThemeFeatureFlag from './UseAccessibleLightThemeFeatureFlag';
export class ConfigWeb extends Config {
    constructor(observer, featureFlags) {
        super(observer, featureFlags);
        _ConfigWeb_instances.add(this);
        __classPrivateFieldGet(this, _ConfigWeb_instances, "m", _ConfigWeb_actOnColorSchemePreference).call(this);
        featureFlags.useAccessibleLightTheme.subscribe((isEnabled) => __classPrivateFieldGet(this, _ConfigWeb_instances, "m", _ConfigWeb_useAccessibleLightThemeFeatureFlagChange).call(this, isEnabled));
    }
}
_ConfigWeb_instances = new WeakSet(), _ConfigWeb_useAccessibleLightThemeFeatureFlagChange = function _ConfigWeb_useAccessibleLightThemeFeatureFlagChange(isEnabled) {
    this.setTheme(isEnabled ? 'Light' : 'InaccessibleLight');
}, _ConfigWeb_actOnColorSchemePreference = function _ConfigWeb_actOnColorSchemePreference() {
    // The following code is intended for client-side use only
    // to prevent server-side errors
    if (typeof window === 'undefined') {
        return;
    }
    if (!('matchMedia' in window)) {
        return;
    }
    const darkModeMediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    this.setTheme(darkModeMediaQueryList.matches
        ? 'Dark'
        : this.getFeatureFlags().useAccessibleLightTheme.isEnabled()
            ? 'Light'
            : 'InaccessibleLight');
    darkModeMediaQueryList.addEventListener('change', (event) => __classPrivateFieldGet(this, _ConfigWeb_instances, "m", _ConfigWeb_onPrefersDarkColorSchemeChange).call(this, event));
}, _ConfigWeb_onPrefersDarkColorSchemeChange = function _ConfigWeb_onPrefersDarkColorSchemeChange(event) {
    this.setTheme(event.matches
        ? 'Dark'
        : this.getFeatureFlags().useAccessibleLightTheme.isEnabled()
            ? 'Light'
            : 'InaccessibleLight');
};
const observer = new Observer();
if (!globalThis.designSystemConfig) {
    globalThis.designSystemConfig = new ConfigWeb(observer, {
        newFont: new NewFontFeatureFlag(observer),
        useAccessibleLightTheme: new UseAccessibleLightThemeFeatureFlag(observer),
    });
}
export default globalThis.designSystemConfig;
